import { render, staticRenderFns } from "./SnippetEdit.vue?vue&type=template&id=3288171b"
import script from "./SnippetEdit.vue?vue&type=script&lang=js"
export * from "./SnippetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports